import { z } from 'zod';
import { safeTextSchema } from '@petseo/shared';
import { pl } from '@/messages/pl';

export const SERVICE_NAME_MAX_LENGTH = 100;
export const SERVICE_PRICE_MAX = 100000;

const DURATION_OPTIONS = [15, 30, 45, 60, 90, 120, 150, 180, 240, 300, 360, 420, 480];

export const serviceSchema = z
  .object({
    name: safeTextSchema(pl.serviceForm.nameLabel, { max: SERVICE_NAME_MAX_LENGTH, requiredMessage: pl.serviceForm.nameRequired }),
    durationMinutes: z
      .number()
      .min(15, pl.serviceForm.durationMin)
      .max(480, pl.serviceForm.durationMax)
      .refine((val) => val % 15 === 0, pl.serviceForm.durationStep),
    isWithoutPrice: z.boolean().optional().default(false),
    price: z.number().optional().catch(undefined),
    isPriceFrom: z.boolean().optional().default(false),
  })
  .superRefine(({ isWithoutPrice, price }, ctx) => {
    if (isWithoutPrice) return;

    if (price === undefined) {
      ctx.addIssue({ code: 'custom', path: ['price'], message: pl.serviceForm.priceRequired });
      return;
    }

    if (price <= 0) {
      ctx.addIssue({ code: 'custom', path: ['price'], message: pl.serviceForm.pricePositive });
      return;
    }

    if (price > SERVICE_PRICE_MAX) {
      ctx.addIssue({ code: 'custom', path: ['price'], message: pl.serviceForm.priceMax });
    }
  });

export type ServiceFormData = z.input<typeof serviceSchema>;

export { DURATION_OPTIONS };
